export default __webpack_public_path__ + "static/media/hummus.d99ec471.jpg";